import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";

export default class ChangeMessageStatus extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "changeMessageStatus";
    }

    public receive(payload: CometOperatorApplication.ChangeMessageStatusCometMessageOpenApiModel): void {
        ClientUserdataStore.updateMessageStatus({
            username: payload.username,
            messageId: payload.id,
            statusId: payload.status
        });
    }

}